import { Text } from '@loadsmart/miranda-react'

import { formatCurrency } from 'core/utils/currency'

export type RateBreakdownProps = {
  haulPrice: number
  fuelPrice?: number | null
}

function RateBreakdown({ haulPrice, fuelPrice }: RateBreakdownProps) {
  if (!fuelPrice) {
    return null
  }

  return (
    <Text variant="body-md">
      Haul {formatCurrency(haulPrice, true)} • Fuel {formatCurrency(fuelPrice, true)}
    </Text>
  )
}

export { RateBreakdown }
